"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { Menu, Settings } from "lucide-react";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { DASHBOARD_NAV_ITEMS, type DashboardNavItem } from "@/components/dashboard/DashboardSidebar";
interface MobileDashboardHeaderProps {
  locale: string;
}
export function MobileDashboardHeader(t0) {
  const $ = _c(24);
  const {
    locale
  } = t0;
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== pathname) {
    t1 = item => {
      if (!pathname) {
        return false;
      }
      const p = pathname.replace(/^\/(fr|en)(?=\/|$)/, "");
      if (item.activePrefix) {
        return p.startsWith(item.activePrefix);
      }
      return p === item.href;
    };
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActive = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/dashboard" className="flex items-center"><Logo size="sm" /></Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LanguageSwitcher />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = locale === "fr" ? "Ouvrir le menu" : "Open menu";
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Menu className="h-5 w-5" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <SheetTrigger asChild={true}><Button variant="ghost" size="icon" aria-label={t4}>{t5}</Button></SheetTrigger>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SheetHeader className="border-b px-4 py-4"><SheetTitle className="flex items-center"><Logo size="sm" /></SheetTitle></SheetHeader>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isActive || $[9] !== locale) {
    t8 = DASHBOARD_NAV_ITEMS.map(item_0 => {
      const active = isActive(item_0);
      const label = locale === "fr" ? item_0.labelFr : item_0.labelEn;
      return <li key={item_0.href}><Link href={item_0.href} onClick={() => setOpen(false)} className={`flex h-10 items-center gap-3 rounded-lg px-3 text-sm font-medium transition-colors ${active ? "bg-primary/12 text-primary" : "text-muted-foreground hover:bg-muted/60 hover:text-foreground"}`}><item_0.icon className="h-4.5 w-4.5 shrink-0" /><span className="truncate">{label}</span></Link></li>;
    });
    $[8] = isActive;
    $[9] = locale;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <nav className="flex-1 overflow-y-auto px-2 py-4"><ul className="space-y-1">{t8}</ul></nav>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setOpen(false);
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Settings className="h-4.5 w-4.5 shrink-0" />;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = locale === "fr" ? "Param\xE8tres" : "Settings";
  let t13;
  if ($[15] !== t12) {
    t13 = <div className="border-t px-2 py-3"><Link href="/settings" onClick={t10} className="flex h-10 items-center gap-3 rounded-lg px-3 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted/60 hover:text-foreground">{t11}<span className="truncate">{t12}</span></Link></div>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t9) {
    t14 = <SheetContent side="right" className="w-72 p-0">{t7}{t9}{t13}</SheetContent>;
    $[17] = t13;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== open || $[21] !== t14 || $[22] !== t6) {
    t15 = <header className="sticky top-0 z-40 flex h-14 shrink-0 items-center justify-between border-b bg-background/95 px-4 backdrop-blur lg:hidden">{t2}<div className="flex items-center gap-2">{t3}<Sheet open={open} onOpenChange={setOpen}>{t6}{t14}</Sheet></div></header>;
    $[20] = open;
    $[21] = t14;
    $[22] = t6;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  return t15;
}